import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { TopBar } from '@weezevent/nacre';

export default function Apps({ organization, minimal = false }) {
    const { t } = useTranslation();
    if (!organization || minimal) {
        return null;
    }

    return (
        <TopBar.Apps headerTitle={t('ticket.global.applications.title')} tooltipTitle={t('ticket.global.applications.main')}>
            <TopBar.Apps.Access
                as="a"
                target="_blank"
                href={`${window.location.origin}/access${organization ? `/O${organization.id}` : ''}`}
                subLabel={t('ticket.global.applications.weezaccess')}
            />
            {/*
            TODO : Uncomment this block when we will be able to know if organization has cashless account AND create environ variable
            to change url  https://admin.nemopay.net/#!/118395 or  https://admin.nemopay.be/#!/118395
            <TopBar.Apps.Pay as="a" target="_blank" href={`${window.location.origin}/pay${organization ? `/O${organization.id}` : ''}`} />
            */}
            <TopBar.Apps.Target
                as="a"
                target="_blank"
                href={`${window.location.origin}/target${organization ? `/O${organization.id}` : ''}`}
                subLabel={t('ticket.global.applications.weeztarget')}
            />
        </TopBar.Apps>
    );
}

Apps.propTypes = {
    organization: PropTypes.object,
    firstEvent: PropTypes.bool
};
